module.exports = __webpack_public_path__ + "media/images/mastercard-fb272b1fdd0f482577cd695eeed30a08.jpg";